import React from "react"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "pages/Authentication/Register"

//Utility
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Profile from "../pages/Profile/index"
import Performance from "../pages/Performance/index.js"
import Video from "pages/Videos"
import Historique from "pages/Historique"
import Application from "pages/Application"
import Notifications from "pages/Notifications"
import Accueille from "pages/accueille"
import ChatInterface from "pages/Chat"
import ResetPasswordRequest from "pages/ResetPassword/ResetPasswordRequest.js"
import ResetPassword from "pages/ResetPassword/ResetPassword"

const userRoutes = [
  //   { path: "/dashboard", component: <Dashboard /> },

  // //profile

  { path: "/profile", component: <Profile />, IsspecialInterface: false },

  { path: "/performance", component: <Performance />, IsspecialInterface: false },

  { path: "/video", component: <Video />, IsspecialInterface: false },

  { path: "/Historique", component: <Historique />, IsspecialInterface: false },

  { path: "/Application", component: <Application />, IsspecialInterface: false },

  { path: "/notifications", component: <Notifications />, IsspecialInterface: false },

  // this route should be at the end of all other routes
  { path: "/", component: <Profile />, IsspecialInterface: false },
  { path: "/accueille", component: <Accueille />, IsspecialInterface: true },
  { path: "/chat/:agentId", component: <ChatInterface />, IsspecialInterface: true },

]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
  { path: "/register", component: <Register /> },
  { path: "/forgot-password", component: <ResetPasswordRequest /> },
  { path: "/reset-password", component: <ResetPassword /> },
]

export { userRoutes, authRoutes }
